import { Grid, Typography } from "@mui/material";
import styles from '../Information.module.scss';
import { useEffect } from "react";


const Religious = () => {

    const serviceofferedList = [
        {
            id: 1,
            offeredName: "Abhisheka",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 2,
            offeredName: "Hiranya Shraddha",
            image: "/images/shivatemple.svg"
        },
        {
            id: 3,
            offeredName: "Shanti Puja",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            offeredName: "Akshara Abhyasa",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            offeredName: "Namakarana",
            image: "/images/shivatemple.svg"
        },
        {
            id: 5,
            offeredName: "Shashti Abda Poorthi",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 6,
            offeredName: "Annaprasana",
            image: "/images/shivatemple.svg"
        },
        {
            id: 6,
            offeredName: "Punyahavachanam",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 7,
            offeredName: "Upanayana",
            image: "/images/shivatemple.svg"
        },
        {
            id: 8,
            offeredName: "Ashtottara Archana",
            image: "/images/shivatemple.svg"
        },
        {
            id: 9,
            offeredName: "Sahasranama Archana",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 10,
            offeredName: "Vastu Puja",
            image: "/images/shivatemple.svg"
        },
        {
            id: 11,
            offeredName: "Bhoomi Puja",
            image: "/images/shivatemple.svg"
        },
        {
            id: 12,
            offeredName: "Samarpana",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 13,
            offeredName: "Vivaha",
            image: "/images/templeimagenew.svg"
        },

    ]
    const residencefordevotee = [
        {
            id: 1,
            image: "/images/shivatemple.svg",
            residencedevotee: "Akshara Abhyasa",
        },
        {
            id: 2,
            image: "/images/templeimagenew.svg",
            residencedevotee: "Mundana",
        },
        {
            id: 3,
            image: "/images/templeimagenew.svg",
            residencedevotee: "Annaprasana",
        },
        {
            id: 4,
            image: "/images/templeimagenew.svg",
            residencedevotee: "Namakarana",

        },
        {
            id: 5,
            image: "/images/shivatemple.svg",
            residencedevotee: "Griha Pravesha",

        },
        {
            id: 6,
            image: "/images/templeimagenew.svg",
            residencedevotee: "Punyahavachanam",

        },
        {
            id: 7,
            image: "/images/shivatemple.svg",
            residencedevotee: "Hiranya Shraddha",

        },
        {
            id: 8,
            image: "/images/templeimagenew.svg",
            residencedevotee: "Sahasranama Archana",

        },
        {
            id: 9,
            image: "/images/shivatemple.svg",
            residencedevotee: "Homa",

        },
        {
            id: 10,
            image: "/images/shivatemple.svg",
            residencedevotee: "Kalyanotsava",

        }
    ]
    const keyevents = [
        {
            id: 1,
            Eventname: "New Year",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 2,
            Eventname: "Hanuman Jayanthi",
            image: "/images/shivatemple.svg"
        },
        {
            id: 3,
            Eventname: "Dhanurmasa",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            Eventname: "Andal Kalyanam",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            Eventname: "Ayyappa Makara Deepa Pooja",
            image: "/images/shivatemple.svg"
        },
        {
            id: 5,
            Eventname: "Makar Sankranti",
            image: "/images/shivatemple.svg"
        },
        {
            id: 6,
            Eventname: "Thai Pongal",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 6,
            Eventname: "Thaipusam",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 7,
            Eventname: "Saraswati Puja",
            image: "/images/shivatemple.svg"
        },
        {
            id: 8,
            Eventname: "Vasantha Panchami",
            image: "/images/shivatemple.svg"
        },
        {
            id: 9,
            Eventname: "Holi",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 10,
            Eventname: "Ugadi Asthanam",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 11,
            Eventname: "Maha Shivaratri",
            image: "/images/shivatemple.svg"
        },
        {
            id: 12,
            Eventname: "Tamil New Year",
            image: "/images/shivatemple.svg"
        },
        {
            id: 13,
            Eventname: "Sri Rama Navami",
            image: "/images/shivatemple.svg"
        },

    ]
    serviceofferedList.sort((a, b) => a.offeredName.localeCompare(b.offeredName));
    residencefordevotee.sort((a, b) => a.residencedevotee.localeCompare(b.residencedevotee));
    keyevents.sort((a, b) => a.Eventname.localeCompare(b.Eventname));
    return (
        <>
            <div className={styles.ReligiousLayout}>
                <Grid>
                    <div className={styles.cardContainer}>
                        <div style={{ padding: "24px" }}>
                            <Typography className={styles.content}>
                                The Shiva-Vishnu Temple is offering religious services for the Hindu community both at the temple and at the residence of devotees. HCCC also serves the community needs through human services, youth & education, and cultural events.<br />
                                The deities in the main temple are: Ganesha, Shiva, Parvati, Kartikeya, Sridevi (Lakshmi), Vishnu, Bhoodevi, Radha-Krishna, Rama-Sita, Navagraha, Hanuman, Kalabhairava, and Dashbhuja Durga. Deity Kanaka Durga Devi is in Kanaka Durga prayer hall. Serving the devotee needs as per Hindu traditions and sampradayas in authentic way is objective of HCCC.
                            </Typography>
                            <Typography className={styles.headercontent}>Religious Services offered at the Temple</Typography>
                            <Grid sx={{ marginTop: "20px", marginLeft: "-10px" }}>
                                <div style={{ width: "100%" }}>
                                    {serviceofferedList.map((offered, id) => (
                                        <div key={offered.id} style={{ display: "inline-block" }}>
                                            <div className={styles.container}>
                                                <Grid container alignItems="center" className={styles.grid}>
                                                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                                                        <img src={offered.image} className={styles.images}/>
                                                        <div className={styles.offeredNameDiv}>
                                                            <Typography className={styles.offeredName}>{offered.offeredName}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                            </Grid>
                            <Typography className={styles.headercontent}>Religious Services offered at the residence of devotees</Typography>
                            <Grid sx={{ marginTop: "20px", marginLeft: "-10px" }}>
                                <div style={{ width: "100%" }}>
                                    {residencefordevotee.map((offered, id) => (
                                        <div key={offered.id} style={{ display: "inline-block" }}>
                                            <div className={styles.container}>
                                                <Grid container alignItems="center" className={styles.grid}>
                                                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                                                        <img src={offered.image} className={styles.images}/>
                                                        <div className={styles.offeredNameDiv}>
                                                            <Typography className={styles.offeredName}>{offered.residencedevotee}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <Grid>
                                </Grid>
                            </Grid>
                            <Typography className={styles.headercontent}>Key Events Celebrated at the Temple</Typography>
                            <Grid sx={{ marginTop: "20px", marginLeft: "-10px" }}>
                                <div style={{ width: "100%" }}>
                                    {keyevents.map((offered, id) => (
                                        <div key={offered.id} style={{ display: "inline-block" }}>
                                            <div className={styles.container}>
                                                <Grid container alignItems="center" className={styles.grid}>
                                                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                                                        <img src={offered.image} className={styles.images}/>
                                                        <div className={styles.offeredNameDiv}>
                                                            <Typography className={styles.offeredName} title={offered.Eventname}>{offered.Eventname}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                <Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </Grid>

            </div>
        </>
    )
}
export default Religious;